export default "__VITE_ASSET__97e5ca5f__"